import React from 'react';

import * as styles from './Notification.module.less';

type NotificationExpandProps = {
  buttonTitle: React.ReactNode;
  expandContent?: React.ReactNode;
  defaultExpanded?: boolean;
};

const NotificationExpand: React.FC<NotificationExpandProps> = ({ buttonTitle, expandContent, defaultExpanded = false }) => {
  const [expanded, setExpanded] = React.useState(defaultExpanded);

  if (!expandContent) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        className={styles['fb-notification-collapse-header']}
        onClick={() => setExpanded(!expanded)}
      >
        <i
          className={`${styles['fb-notification-collapse-arrow']} ${expanded ? 'fb-icon--arrow-up' : 'fb-icon--arrow-down'}`}
        />{' '}
        <span className={styles['fb-notification-collapse-label']}>{buttonTitle}</span>
      </button>
      {expanded && expandContent}
    </>
  );
};

export default NotificationExpand;
